const root = process.env.REACT_APP_BACKEND_GCS+"/api";
const rutasAuth = { 
    auth : root +  "/Authenticate/login"
}

export default rutasAuth;